import { React, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { Stack, Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TablePagination from "@mui/material/TablePagination";
import { useDispatch } from "react-redux";
import { getCurrentMonth } from "../Redux/BussinessPOCSlice";
import { useSelector } from "react-redux";
import TLFileUpload from "./TLFileUpload";
import "./CourseMasterData.css";
import InputLabel from "@mui/material/InputLabel";
import { getTrainingListMonthWise } from "../Redux/THSlice";
import SearchCourse from "./SearchCourse";

const THTrainingList = () => {
 const [page, setPage] = useState(0);
 const dispatch = useDispatch();
 const trainingList = useSelector((state) => state.traininghost.monthWIseTrainingList);
 const [month, setMonth] = useState("");
 const currentMonth = useSelector((state) => state.poc.currentMonth);
 const currentMonthIndex = useSelector((state) => state.poc.currentMonthIndex);
 const [filteredTrainingListStatus, setFilteredTrainingListStatus] = useState(0);
 const [filteredTrainingList, setFilteredTrainingList] = useState([]);
 const [rowsPerPage, setRowsPerPage] = useState(10);

 const handleChangePage = (event, newPage) => {
  setPage(newPage);
 };
 const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  setPage(0);
 };

 const theme = createTheme({
  typography: {
   fontFamily: "Graphik-Regular",
  },
 });

 useEffect(() => {
  dispatch(getCurrentMonth());
  //   setMonth(currentMonthIndex);
  //   dispatch(getTrainingListMonthWise(currentMonth));

  const monthNames = [
   "January",
   "February",
   "March",
   "April",
   "May",
   "June",
   "July",
   "August",
   "September",
   "October",
   "November",
   "December",
  ];

  const selectedMonthName = monthNames[currentMonthIndex - 1];
  dispatch(getTrainingListMonthWise(selectedMonthName));
 }, []);

 const handleChange = (event) => {
  setMonth(event.target.value);
  const monthNames = [
   "January",
   "February",
   "March",
   "April",
   "May",
   "June",
   "July",
   "August",
   "September",
   "October",
   "November",
   "December",
  ];

  const selectedMonthName = monthNames[event.target.value - 1];
  dispatch(getTrainingListMonthWise(selectedMonthName));
  setPage(0);
 };
 useEffect(() => {
  dispatch(getCurrentMonth());
  setMonth(currentMonthIndex);
 }, [currentMonthIndex]);
 return (
  <>
   <ThemeProvider theme={theme}>
    <div className="upload_section">
     <h3 className="upload_section_header">Training List</h3>
     <p className="upload_section_para">
      This section allows you to review the list of scheduled training sessions and upload
      the upcoming training session list which will be available for business teams to
      upload their nominations.
     </p>
     <p className="upload_section_para">
      You also have options to filter the scheduled training for a specific month.
     </p>
    </div>
    <Stack direction={"row"} justifyContent="space-between" sx={{ marginBottom: "20px" }}>
     <TLFileUpload />
     <SearchCourse
      trainingList={trainingList}
      setFilteredTrainingList={setFilteredTrainingList}
      setFilteredTrainingListStatus={setFilteredTrainingListStatus}
     />
     <Box className="select_month_section">
      <FormControl fullWidth>
       <InputLabel id="demo-simple-select-label">Month</InputLabel>
       <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={month}
        label="Month"
        onChange={handleChange}
       >
        <MenuItem className="menu_li_select" value={1}>
         January
        </MenuItem>
        <MenuItem className="menu_li_select" value={2}>
         February
        </MenuItem>
        <MenuItem className="menu_li_select" value={3}>
         March
        </MenuItem>
        <MenuItem className="menu_li_select" value={4}>
         April
        </MenuItem>
        <MenuItem className="menu_li_select" value={5}>
         May
        </MenuItem>
        <MenuItem className="menu_li_select" value={6}>
         June
        </MenuItem>
        <MenuItem className="menu_li_select" value={7}>
         July
        </MenuItem>
        <MenuItem className="menu_li_select" value={8}>
         August
        </MenuItem>
        <MenuItem className="menu_li_select" value={9}>
         September
        </MenuItem>
        <MenuItem className="menu_li_select" value={10}>
         October
        </MenuItem>
        <MenuItem className="menu_li_select" value={11}>
         November
        </MenuItem>
        <MenuItem className="menu_li_select" value={12}>
         December
        </MenuItem>
       </Select>
      </FormControl>
     </Box>
    </Stack>
    {trainingList.length != 0 ? (
     <Box className="upload_table">
      <TableContainer component={Paper}>
       <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
        <TableHead>
         <TableRow>
          <TableCell align="center">Sl No</TableCell>
          <TableCell align="center">Course Code</TableCell>

          <TableCell align="center">Session Code</TableCell>
          <TableCell align="center">Course Name</TableCell>
          <TableCell align="center">Start Date </TableCell>
          <TableCell align="center">End Date</TableCell>
          <TableCell align="center">Delivery Mode</TableCell>
          <TableCell align="center">Duration</TableCell>

          <TableCell align="center" sx={{ width: "10%" }}></TableCell>
         </TableRow>
        </TableHead>
        <TableBody>
         {trainingList.length != 0 && filteredTrainingListStatus === 0 && (
          <ShowTrainingList
           trainingList={trainingList}
           rowsPerPage={rowsPerPage}
           page={page}
          />
         )}
         {trainingList.length != 0 && filteredTrainingListStatus === 1 && (
          <ShowTrainingList
           trainingList={filteredTrainingList}
           rowsPerPage={rowsPerPage}
           page={page}
          />
         )}
         {trainingList.length != 0 &&
          filteredTrainingListStatus === 1 &&
          filteredTrainingList.length === 0 && (
           <TableRow>
            <TableCell>Searched courses not found.</TableCell>
           </TableRow>
          )}
        </TableBody>
       </Table>
      </TableContainer>
      <TablePagination
       className="manageNomination_pagination"
       component="div"
       count={trainingList.length != 0 ? trainingList.length : null}
       page={page}
       onPageChange={handleChangePage}
       rowsPerPage={rowsPerPage}
       onRowsPerPageChange={handleChangeRowsPerPage}
       sx={{ width: "100% !important" }}
      />
     </Box>
    ) : (
     <Stack
      justifyContent={"center"}
      alignItems={"center"}
      sx={{ marginTop: "30px", marginBottom: "100px" }}
     >
      <Stack
       spacing={2}
       justifyContent={"center"}
       alignItems={"center"}
       sx={{
        border: "solid 1px #DEDEDE",
        borderRadius: "5px",
        width: "70%",
        padding: "30px",
       }}
      >
       <img style={{ width: "100px" }} src="/images/POC/norecords.png"></img>
       <Stack direction={"row"} spacing={1}>
        <img
         style={{ width: "20px", height: "20px", marginTop: "3px" }}
         src="/images/POC/norecordsalert.png"
        ></img>
        <Typography sx={{ fontSize: "20px" }}>
         Training List for this month has not published yet!!!
        </Typography>
       </Stack>
      </Stack>
     </Stack>
    )}
   </ThemeProvider>
  </>
 );
};

function ShowTrainingList({ trainingList, rowsPerPage, page }) {
 return (
  <>
   {trainingList
    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    .map((row, index) => (
     <TableRow key={row.sno}>
      <TableCell align="center" scope="row">
       {row.sno}.
      </TableCell>
      <TableCell align="center" scope="row">
       {row.courseCode}
      </TableCell>
      <TableCell align="center">{row.sessionCode}</TableCell>
      <TableCell align="center">{row.courseName}</TableCell>
      <TableCell align="center">{row.startDate}</TableCell>
      <TableCell align="center">{row.endDate}</TableCell>
      <TableCell align="center">{row.deliveryMode}</TableCell>
      <TableCell align="center">{row.duration}</TableCell>

      <TableCell align="center"></TableCell>
     </TableRow>
    ))}
  </>
 );
}

export default THTrainingList;
